import { render, staticRenderFns } from "./trouble-avoid-account-restrictions.vue?vue&type=template&id=15d8d6e1"
import script from "./trouble-avoid-account-restrictions.vue?vue&type=script&lang=js"
export * from "./trouble-avoid-account-restrictions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports